/**
 * It checks for view app container and adds ESRI CSS & JS-Library to document head
 *
 * @returns {Promise<void>|Promise<unknown>}
 */
export default function loadArcGIS() {
  // Check if container #viewDiv is present, that is used for the arcgis map rendering
  const viewDiv = document.getElementById('viewDiv');
  if (!viewDiv) {
    console.warn('⛔ #viewDiv element not fount in DOM – ArcGIS could not be loaded.');
    throw new Error('#viewDiv not found');
  }

  // Check if ArcGIS is loaded
  if (window.require && window.require.specified) {
    return Promise.resolve();
  }

  // CSS-Resource link added
  const cssHref = 'https://js.arcgis.com/4.31/esri/themes/light/main.css';
  if (!document.querySelector(`link[href="${cssHref}"]`)) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssHref;
    document.head.appendChild(link);
  }

  // Script import added
  const scriptSrc = 'https://js.arcgis.com/4.31/';
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${scriptSrc}"]`)) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = scriptSrc;
    script.onload = () => {
      resolve();
    };

    script.onerror = loadError => reject(loadError);
    document.head.appendChild(script);
  });
}
